export default __webpack_public_path__ + "static/AdefiantmovetotheNorwegianArctic-751b6b8d470793b14b482f9d21c4e07e.jpg";